export class CancellationReasons {
    static moduleName = 'cancellationReasons';
    static moduleEntityName = 'cancellationReasonsEntity';
    static listTitle = 'Справочник причин отмены';
    static createTitle = 'Добавление новой причины отмены';
    static apiPrefix = 'cancellation-reasons';
}